import axios from "axios";

import * as client from "../client";

// FastAPI reports handled failures as ``{ detail: "..." }``. A 422 instead
// carries a list of validation errors, so anything non-string is rejected here
// rather than reaching a toast as "[object Object]".
const detailFromBody = (body: unknown): string | undefined => {
  if (
    body &&
    typeof body === "object" &&
    "detail" in body &&
    typeof body.detail === "string"
  ) {
    return body.detail;
  }
  return undefined;
};

// The server's own reason for a failed request, for showing in place of a fixed
// message. Takes ``unknown`` so it can be called straight from a ``catch``.
export const apiErrorDetail = (err: unknown): string | undefined =>
  err instanceof client.ApiError ? detailFromBody(err.body) : undefined;

// Same reason, for a request made through ``fetchBinary``: those responses
// arrive as raw ArrayBuffers via axios rather than as a parsed ``ApiError``, so
// the body has to be decoded before it can be read.
export const errorDetailFromBinaryResponse = (
  e: unknown
): string | undefined => {
  if (!axios.isAxiosError(e)) {
    return undefined;
  }
  const data: unknown = e.response?.data;
  if (!(data instanceof ArrayBuffer)) {
    return undefined;
  }
  try {
    return detailFromBody(JSON.parse(new TextDecoder().decode(data)));
  } catch {
    return undefined;
  }
};
